import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
interface LegalModalProps {
  isOpen: boolean;
  onClose: () => void;
  type: 'terms' | 'privacy';
}
export function LegalModal({
  isOpen,
  onClose,
  type
}: LegalModalProps) {
  const content = {
    terms: {
      title: 'Términos y Condiciones',
      body: <div className="space-y-4 text-gray-300 text-sm leading-relaxed" data-id="element-66">
          <p data-id="element-67">
            <strong className="text-white" data-id="element-68">1. Producto Digital</strong>
            <br data-id="element-69" />
            El "Plan Anti-Pantalla 30 Días" es un producto digital en formato
            PDF. Una vez realizada la compra, recibirás acceso inmediato al
            material descargable.
          </p>

          <p data-id="element-70">
            <strong className="text-white" data-id="element-71">2. Uso Personal</strong>
            <br data-id="element-72" />
            El contenido es para uso personal y familiar del comprador. Queda
            prohibida su reproducción, distribución o reventa total o parcial
            sin autorización expresa.
          </p>

          <p data-id="element-73">
            <strong className="text-white" data-id="element-74">3. Naturaleza del Contenido</strong>
            <br data-id="element-75" />
            Este material es educativo y orientativo. No constituye asesoría
            profesional en psicología, psiquiatría ni medicina. No reemplaza el
            acompañamiento profesional cuando se requiere.
          </p>

          <p data-id="element-76">
            <strong className="text-white" data-id="element-77">4. Resultados</strong>
            <br data-id="element-78" />
            Los resultados pueden variar según cada familia, la consistencia en
            la aplicación y las circunstancias particulares de cada hogar. No se
            garantizan resultados específicos.
          </p>

          <p data-id="element-79">
            <strong className="text-white" data-id="element-80">5. Política de Reembolso</strong>
            <br data-id="element-81" />
            Dado que se trata de un producto digital de descarga inmediata, las
            solicitudes de reembolso serán evaluadas caso por caso dentro de los
            primeros 7 días posteriores a la compra.
          </p>

          <p data-id="element-82">
            <strong className="text-white" data-id="element-83">6. Modificaciones</strong>
            <br data-id="element-84" />
            Nos reservamos el derecho de actualizar estos términos. La versión
            vigente estará siempre disponible en esta página.
          </p>
        </div>
    },
    privacy: {
      title: 'Política de Privacidad',
      body: <div className="space-y-4 text-gray-300 text-sm leading-relaxed" data-id="element-85">
          <p data-id="element-86">
            <strong className="text-white" data-id="element-87">1. Datos Recopilados</strong>
            <br data-id="element-88" />
            Recopilamos únicamente los datos necesarios para procesar tu compra:
            nombre, correo electrónico y datos de pago (procesados por la
            pasarela de pago, no almacenados por nosotros).
          </p>

          <p data-id="element-89">
            <strong className="text-white" data-id="element-90">2. Uso de la Información</strong>
            <br data-id="element-91" />
            Tu información se utiliza exclusivamente para: entregar el producto
            adquirido, enviar comunicaciones relacionadas con tu compra y, si lo
            autorizas, enviarte contenido educativo relacionado.
          </p>

          <p data-id="element-92">
            <strong className="text-white" data-id="element-93">3. Protección de Datos</strong>
            <br data-id="element-94" />
            Implementamos medidas de seguridad para proteger tu información
            personal. No vendemos, alquilamos ni compartimos tus datos con
            terceros con fines comerciales.
          </p>

          <p data-id="element-95">
            <strong className="text-white" data-id="element-96">4. Correos Electrónicos</strong>
            <br data-id="element-97" />
            Podrás darte de baja de nuestras comunicaciones en cualquier momento
            mediante el enlace incluido en cada correo.
          </p>

          <p data-id="element-98">
            <strong className="text-white" data-id="element-99">5. Cookies</strong>
            <br data-id="element-100" />
            Nuestro sitio puede utilizar cookies para mejorar la experiencia de
            navegación y analizar el tráfico. Puedes configurar tu navegador
            para rechazarlas.
          </p>

          <p data-id="element-101">
            <strong className="text-white" data-id="element-102">6. Contacto</strong>
            <br data-id="element-103" />
            Para cualquier consulta sobre tus datos personales, puedes
            escribirnos y atenderemos tu solicitud en un plazo máximo de 30
            días.
          </p>
        </div>
    }
  };
  const {
    title,
    body
  } = content[type];
  return <AnimatePresence data-id="element-104">
      {isOpen && <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} exit={{
      opacity: 0
    }} className="fixed inset-0 z-[100] flex items-center justify-center p-4" onClick={onClose} data-id="element-105">
          {/* Backdrop */}
          <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-106" />

          {/* Modal */}
          <motion.div initial={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} animate={{
        opacity: 1,
        scale: 1,
        y: 0
      }} exit={{
        opacity: 0,
        scale: 0.95,
        y: 20
      }} transition={{
        duration: 0.2
      }} onClick={e => e.stopPropagation()} className="relative bg-[#1a2740] rounded-xl shadow-2xl border border-gray-700 w-full max-w-lg max-h-[80vh] overflow-hidden" data-id="element-107">
            {/* Header */}
            <div className="flex items-center justify-between p-5 border-b border-gray-700" data-id="element-108">
              <h3 className="text-lg font-serif font-bold text-white" data-id="element-109">
                {title}
              </h3>
              <button onClick={onClose} className="text-gray-400 hover:text-white transition-colors p-1" aria-label="Cerrar" data-id="element-110">
                <X className="w-5 h-5" data-id="element-111" />
              </button>
            </div>

            {/* Body */}
            <div className="p-5 overflow-y-auto max-h-[60vh]" data-id="element-112">{body}</div>

            {/* Footer */}
            <div className="p-4 border-t border-gray-700 text-center" data-id="element-113">
              <button onClick={onClose} className="px-6 py-2 bg-[#c9a84c] text-[#0f1923] rounded-lg font-semibold text-sm hover:bg-[#d4af5a] transition-colors" data-id="element-114">
                Entendido
              </button>
            </div>
          </motion.div>
        </motion.div>}
    </AnimatePresence>;
}